module.exports = __webpack_public_path__ + "static/fonts/Poppins-Bold.08c20a4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-Bold.ttf
// module id = 1021
// module chunks = 11